import {
  Donor,
  GET_NEXT_SCHEDULE,
  GET_SCHEDULED_DRUGS,
  SEARCH_DONORS,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

interface SearchDonorsResponse {
  donors: {
    items: Donor[];
    totalCount: number;
  };
}

export const donorsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    searchDonors: build.query({
      query: (variables) => ({
        document: SEARCH_DONORS,
        variables,
      }),
      transformResponse: (response: SearchDonorsResponse) => response,
    }),
    getNextSchedule: build.query({
      query: (donorId) => ({
        document: GET_NEXT_SCHEDULE,
        variables: { donorId },
      }),
    }),
    getScheduledDrugs: build.query({
      query: (donorId) => ({
        document: GET_SCHEDULED_DRUGS,
        variables: { donorId },
      }),
    }),
  }),
});

export const {
  useGetNextScheduleQuery,
  useLazyGetNextScheduleQuery,
  useLazyGetScheduledDrugsQuery,
  useLazySearchDonorsQuery,
  useSearchDonorsQuery,
} = donorsApi;
